import { Button, Space } from "antd";
import {
  FBIcon, EnvelopIcon, LinkIcon, TikTokIcon, InstagramIcon,
  TwitterIcon
} from "@components/icons/Icons";


export interface Handle {
  url: string;
  icon: string;
  type: string;
  class: string;
}

interface SocialMediaButtonsProps {
  style?: any;
  className?: string;
  handles?: Handle[];
}

const defaultProps: SocialMediaButtonsProps = {
  handles: []
};

const icons = {
  Facebook: <FBIcon />,
  Instagram: <InstagramIcon />,
  Twitter: <TwitterIcon />,
  TikTok: <TikTokIcon />,
  Email: <EnvelopIcon />,
  Web: <LinkIcon />,
  Tiktok: <TikTokIcon />,
}

const SocialMediaButtons = ({ style, className, handles }: SocialMediaButtonsProps) => {
  const css: string[] = ["social-media"];

  if (className) {
    css.push(className);
  }

  return (
    <Space align="center" size={`small`} className={css.join(' ')}>
      {handles && handles.map((handle) => {
        const DyntamicIcon = icons[handle.type];
        return (
          <Button className="pad-x-0" size="small" href={handle.url} type="link" title="email">
            {DyntamicIcon}
          </Button>
        )
      })}
    </Space>
  );
};

SocialMediaButtons.defaultProps = defaultProps;

export default SocialMediaButtons;
